import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _excluded = ["fields", "reset"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.string.trim.js";
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { formatLanguageCode } from 'i18n/options';
import { useUpdateAssets, useDeleteAsset } from 'actions/assets';
import filterObject from 'utils/filterObject';
import Stack from 'components/Stack';
import { ConfirmationModal } from 'screens/ContentEditorModals';
import { useLinkEditorForm } from 'screens/ContentEditorModals/editorForms';
import { formatAssetEditorPayloadForApi } from 'screens/AssetEditor';
import FormWrapper from './FormWrappers';
import GeneralDetailsCard from './Cards/GeneralDetailsCard';
import AdvancedSettingsCard from './Cards/AdvancedSettingsCard';
import LinkDetailsCard from './Cards/LinkDetailsCard';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var VIEWS = {
  DETAILS: 'details',
  CONFIRMATION: 'confirmation'
};
function NewLinkEditorModal(_ref) {
  var content = _ref.content,
    parentPlaylist = _ref.parentPlaylist,
    aiSuggestions = _ref.aiSuggestions,
    inContentManagerContext = _ref.inContentManagerContext,
    onClose = _ref.onClose,
    onSubmit = _ref.onSubmit;
  var _useTranslation = useTranslation(),
    i18n = _useTranslation.i18n;
  var defaultLocale = parentPlaylist.locale || formatLanguageCode(i18n.language);
  var _useState = useState(VIEWS.DETAILS),
    _useState2 = _slicedToArray(_useState, 2),
    view = _useState2[0],
    setView = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isSubmissionLoading = _useState4[0],
    setIsSubmissionLoading = _useState4[1];
  var _useUpdateAssets = useUpdateAssets({
      assetIds: [content.id],
      parentPlaylistIds: parentPlaylist.id
    }),
    updateAssets = _useUpdateAssets.updateAssets;
  var _useDeleteAsset = useDeleteAsset({
      assetId: content.id
    }),
    isDeleting = _useDeleteAsset.isPending,
    softDeleteAsset = _useDeleteAsset.deleteAsset;
  var _useLinkEditorForm = useLinkEditorForm({
      content: content,
      aiSuggestions: aiSuggestions,
      defaultLocale: defaultLocale
    }),
    fields = _useLinkEditorForm.fields,
    resetAssetEditorForm = _useLinkEditorForm.reset,
    form = _objectWithoutProperties(_useLinkEditorForm, _excluded);
  useEffect(function () {
    // When our AI suggestions have been loaded, soft-reload the form
    // to populate empty fields.
    if (aiSuggestions) {
      resetAssetEditorForm({
        keepUserValues: true
      });
    }
  }, [aiSuggestions, resetAssetEditorForm]);
  var handleSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _fields$externalRefId;
      var contentData, cleanedContentData, assetUpdate, _t, _t2;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            contentData = {
              name: fields.name.value,
              webUrl: fields.webUrl.value,
              description: fields.description.changedValue,
              locale: fields.locale.value,
              tags: fields.tags.changedValue,
              thumbnailId: fields.thumbnailId.changedValue,
              customType: fields.customType.value,
              completionTime: fields.completionTime.wasChanged ? Number(fields.completionTime.value) : undefined,
              openInIframe: fields.openInIframe.value,
              parentId: fields.parentId.wasChanged ? fields.parentId.changedValue : content.parentId,
              markAsDoneMode: fields.markAsDoneMode.value,
              externalRefId: fields.externalRefId.wasChanged ? ((_fields$externalRefId = fields.externalRefId.value) === null || _fields$externalRefId === void 0 ? void 0 : _fields$externalRefId.trim()) || null : undefined,
              excludeFromAi: fields.excludeFromAi.changedValue,
              owner: fields.owner.changedValue
            };
            cleanedContentData = filterObject(contentData); // Add flag for setting asset to published
            cleanedContentData.published = true;
            _context.prev = 1;
            setIsSubmissionLoading(true);
            _context.next = 2;
            return updateAssets(formatAssetEditorPayloadForApi({
              parentPlaylistId: parentPlaylist.id,
              changes: cleanedContentData
            }));
          case 2:
            assetUpdate = _context.sent;
            _context.next = 4;
            break;
          case 3:
            _context.prev = 3;
            _t = _context["catch"](1);
            setIsSubmissionLoading(false);
            return _context.abrupt("return");
          case 4:
            if (!parentPlaylist.id) {
              _context.next = 8;
              break;
            }
            _context.prev = 5;
            _context.next = 6;
            return onSubmit(assetUpdate);
          case 6:
            setIsSubmissionLoading(false);
            onClose();
            _context.next = 8;
            break;
          case 7:
            _context.prev = 7;
            _t2 = _context["catch"](5);
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 3], [5, 7]]);
    }));
    return function handleSubmit() {
      return _ref2.apply(this, arguments);
    };
  }();
  var deleteAsset = function deleteAsset() {
    softDeleteAsset();
    onClose();
  };
  var modals = _defineProperty(_defineProperty({}, VIEWS.DETAILS, /*#__PURE__*/_jsx(FormWrapper, {
    hasChanges: true,
    isEditMode: false,
    isLoading: isSubmissionLoading,
    isSubmitDisabled: form.hasErrors,
    inContentManagerContext: inContentManagerContext,
    assetContentType: "web",
    onSubmit: handleSubmit,
    onClose: function onClose() {
      return setView(VIEWS.CONFIRMATION);
    },
    children: /*#__PURE__*/_jsxs(Stack, {
      spacing: "m",
      children: [/*#__PURE__*/_jsx(GeneralDetailsCard, {
        isEditMode: false,
        fields: fields,
        content: content,
        aiSuggestions: aiSuggestions
      }), /*#__PURE__*/_jsx(AdvancedSettingsCard, {
        assetContentType: "web",
        isDistributed: false,
        fields: fields,
        content: content
      }), /*#__PURE__*/_jsx(LinkDetailsCard, {
        isDistributed: false,
        fields: fields
      })]
    })
  })), VIEWS.CONFIRMATION, /*#__PURE__*/_jsx(ConfirmationModal, {
    isLoading: isDeleting,
    onConfirm: deleteAsset,
    onCancel: function onCancel() {
      return setView(VIEWS.DETAILS);
    },
    isEditMode: false
  }));
  return modals[view];
}
export default NewLinkEditorModal;